import React, { CSSProperties, useState } from 'react'

import s from './styles.module.scss'

import { IconSvg } from '../icons'

export interface IInformativeProps {
  style?: CSSProperties
  styleIcon?: CSSProperties
  className?: string
  displayBlock: boolean
  setDisplayBlock: React.Dispatch<React.SetStateAction<boolean>>
  children: React.ReactNode
}

const InformativeBlock = ({
  style,
  styleIcon = {},
  displayBlock,
  setDisplayBlock,
  children,
}: IInformativeProps) => {
  const [posY, setPosY] = useState<number>(0)
  const [posX, setPosX] = useState<number>(0)
  return (
    <>
      <div className={s.informative} style={style}>
        <div
          ref={(el) => {
            if (!el) {
              return
            }
            setPosY(el.getBoundingClientRect().y)
            setPosX(el.getBoundingClientRect().x)
          }}
          className={s.icon}
          onMouseMove={() => {
            setDisplayBlock(true)
          }}
          onMouseLeave={() => {
            setDisplayBlock(false)
          }}
          style={styleIcon}
        >
          <IconSvg.IconInfo color='var(--clr-primary-400)' />
        </div>
        <div
          className={s.infoBlock}
          style={{
            display: displayBlock ? 'block' : '',
            top: `${posY + 17}px`,
            left: `${posX + 20}px`,
          }}
        >
          {children}
        </div>
      </div>
    </>
  )
}

export default InformativeBlock
